<template lang="pug">
.table-wrapper(:class="wrapperClasses")
  .scrollable(
    ref="scrollable"
    @scroll="onScroll"
  )
    slot
</template>

<script>
import { throttle } from 'lodash-es';

export default {
  name: 'AppScrollableTable',
  props: {
    hasFixedColumn: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    isScrollable: false,
    isScrolled: false,
    isFullyScrolled: false,
  }),
  computed: {
    wrapperClasses() {
      return {
        'is-scrollable': this.isScrollable,
        'is-fully-scrolled': this.isFullyScrolled,
        'is-scrolled': this.isScrolled,
        'has-fixed-column': this.hasFixedColumn,
      };
    },
  },
  mounted() {
    window.addEventListener('resize', this.onResize);

    this.$nextTick(() => {
      this.checkIfScrollable();
      this.checkScrollPosition();
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    onScroll: throttle(function () {
      this.checkScrollPosition();
    }, 100),
    onResize: throttle(
      () =>
        function () {
          this.checkIfScrollable();
        },
      100,
    ),
    checkIfScrollable() {
      const scrollable = this.$refs.scrollable;

      if (scrollable) {
        this.isScrollable = scrollable.scrollWidth > scrollable.offsetWidth;
      }
    },
    checkScrollPosition() {
      const scrollable = this.$refs.scrollable;

      if (scrollable) {
        this.$emit('table-scroll');
        this.isFullyScrolled = scrollable.scrollWidth - scrollable.scrollLeft <= scrollable.offsetWidth;
        this.isScrolled = scrollable.scrollLeft > 0;
      }
    },
  },
};
</script>
